const EventTypes = Object.freeze({
  SS_REQUEST_FAILED_401: 'SS_REQUEST_FAILED_401',
  SS_DURATION_UPDATE: 'SS_DURATION_UPDATE',
  SS_DISABLE_CALENDAR: 'SS_DISABLE_CALENDAR',
});

export { EventTypes };
